import { jsx as f } from "react/jsx-runtime";
import { s as a } from "../../../Popover.module-B-m2_dp_.js";
import { usePopover as m } from "../hooks/usePopover.js";
import { useMemo as c, cloneElement as l } from "react";
const w = ({
  children: o,
  ...n
}) => {
  const t = m(), e = o == null ? void 0 : o.props, i = c(() => {
    if (t != null && t.show)
      return [
        ...t.getAriaControls(),
        e["aria-controls"],
        t.api.context.floatingId
      ].join(" ").trim();
  }, [e, t]);
  return /* @__PURE__ */ f("div", { ...n, className: a.activator, children: o && t && l(
    o,
    t.interactions.getReferenceProps({
      "aria-controls": i,
      role: e.role,
      ref: t == null ? void 0 : t.api.refs.setReference,
      onFocus: (s) => {
        var r;
        (r = e == null ? void 0 : e.onFocus) == null || r.call(
          e,
          s
        ), !(t != null && t.disabledAutoToggle) && setTimeout(() => {
          s.relatedTarget && s.relatedTarget.closest(`.${a.content}`) && s.target === t.api.elements.reference && t.show && t.setShowWithReason(!1, s.nativeEvent);
        }, 300);
      }
    })
  ) });
};
export {
  w as PopoverActivator
};
